import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../src/firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { TextField, Button, Typography, Container, MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const AddMovie = () => {
  const navigate = useNavigate();
  const [movie, setMovie] = useState({
    title: "",
    genre: "",
    director: "",
    duration: "",
    cast: "",
    crew: "",
    targetFunding: "",
    unitPrice: "",
  });

  const handleChange = (e) => {
    setMovie({ ...movie, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      await addDoc(collection(db, "movies"), {
        ...movie,
        cast: movie.cast.split(",").map((c) => c.trim()), // Convert cast to array
        crew: movie.crew.split(",").map((c) => c.trim()), // Convert crew to array
        createdAt: Timestamp.now(),
        publish: "1",
      });

      navigate("/admin/home/movies");
    } catch (error) {
      console.error("Error adding movie:", error);
    }
  };

  return (
    <Container sx={{ backgroundColor: "#ffffff", padding: "24px", borderRadius: "8px" }}>
      <Typography variant="h4" gutterBottom>Add Movie</Typography>
      <TextField fullWidth label="Title" name="title" value={movie.title} onChange={handleChange} margin="normal" />

      {/* Genre Dropdown */}
      <FormControl fullWidth margin="normal">
        <InputLabel>Genre</InputLabel>
        <Select name="genre" value={movie.genre} onChange={handleChange}>
          <MenuItem value="">Select a genre</MenuItem>
          <MenuItem value="action">Action</MenuItem>
          <MenuItem value="comedy">Comedy</MenuItem>
          <MenuItem value="drama">Drama</MenuItem>
          <MenuItem value="sci-fi">Sci-Fi</MenuItem>
          <MenuItem value="horror">Horror</MenuItem>
          <MenuItem value="romance">Romance</MenuItem>
          <MenuItem value="thriller">Thriller</MenuItem>
          
        </Select>
      </FormControl>

      <TextField fullWidth label="Director" name="director" value={movie.director} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Duration" name="duration" value={movie.duration} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Cast (comma-separated)" name="cast" value={movie.cast} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Crew (comma-separated)" name="crew" value={movie.crew} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Target Funding" name="targetFunding" value={movie.targetFunding} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Unit Price" name="unitPrice" value={movie.unitPrice} onChange={handleChange} margin="normal" />

      <Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: "16px" }}>
        Save Movie
      </Button>
    </Container>
  );
};

export default AddMovie;
